import CongratsScreen from 'features/believe/application/CongratsScreen/CongratsScreen';
import React from 'react';

export default function Page() {
  return <CongratsScreen />;
}
